
<div id="app">
  <ConfirmDialog
    :dialog-id="confirmDialogId"
    :dialog-vertical-center="true"
    dialog-title="New version available"
    dialog-message="You need to reload the page for everything to work correctly with the updated version. Do you want to do it now?"
    @ok="updateVersion"
    @hidden="onDialogHidden"
  />
  <router-view />
</div>
